<template>
  <v-data-table
    :headers="headers"
    :items="sources"
    :footer-props="{
      'items-per-page-options': [5],
    }"
    disable-sort
  >
    <template v-slot:item="{ item, index }">
      <tr>
        <td>
          <span class="text-capitalize">{{
            item.name == "map"
              ? `${item.name} (${item.location.radious} Km)`
              : item.name
          }}</span>
        </td>
        <td>
          <span
            >{{ item.name == "map" ? `${item.location}` : item.keywords }}
          </span>
        </td>
        <td class="d-flex justify-end align-center">
          <span>{{ item.numDocs.toLocaleString() }}</span>
        </td>
        <td>{{ item.from || "--" }}</td>
        <td>{{ item.to || "--" }}</td>
        <td>
          <div class="d-flex justify-center align-center">
            <div v-if="item.status == 'created'" class="d-flex align-center">
              <v-icon size="14" color="grey" left>sync</v-icon>
              <span>Pendiente</span>
            </div>
            <div v-if="item.status == 'processed'" class="d-flex align-center">
              <v-icon size="14" color="green" left>check_circle</v-icon>
              <span>Procesada</span>
            </div>
            <div v-if="item.status == 'error'" class="d-flex align-center">
              <v-icon size="14" color="red" left>error</v-icon>
              <span>Error</span>
            </div>
          </div>
        </td>
        <td>
          <div class="d-flex justify-center align-center">
            <v-icon
              @click="deleteSource(item, index)"
              color="red lighten-2"
              size="20"
              small
              >delete</v-icon
            >
          </div>
        </td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
export default {
  data() {
    return {
      headers: [
        {
          text: "Nombre",
          align: "start",
          value: "name",
          width: "15%",
        },
        {
          text: "Keywords",
          align: "start",
          value: "keywords",
          width: "25%",
        },
        {
          text: "Registros",
          align: "center",
          value: "numDocs",
          width: "8%",
        },
        {
          text: "Desde",
          align: "center",
          value: "from",
          width: "15%",
        },
        {
          text: "Hasta",
          align: "center",
          value: "to",
          width: "15%",
        },
        {
          text: "Estado",
          align: "center",
          value: "status",
          width: "9%",
        },
        { text: "Borrar", align: "center", value: "delete", width: "10%" },
      ],
    };
  },
  props: {
    sources: {
      type: Array,
      default: () => [
        {
          name: "",
          keywords: "",
          numDocs: undefined,
          from: "",
          to: "",
        },
      ],
    },
  },
  methods: {
    async deleteSource(item, index) {
      const res = await this.$confirm(
        ` <h1 class="subtitle-1">Estas seguro que quieres eliminar esta fuente?</h1>`,
        {
          buttonTrueText: "Eliminar",
          buttonFalseText: "Cerrar",
          buttonTrueColor: "red lighten-2",
          color: "primary",
          icon: "delete",
          title: "Eliminar Fuente",
          width: 600,
        }
      );
      if (res) {
        this.$emit("delete-source", item, index);
      }
    },
  },
};
</script>
